const cookieUsageLocalStorageKey = "CookieUsageAccepted";
export default {
  name: "CookieUsage",

  data() {
    return {
      cookieUsageAccepted: localStorage.getItem(cookieUsageLocalStorageKey) || true,
      authTarget: envs.authTarget
    };
  },

  methods: {
    close() {
      localStorage.setItem(cookieUsageLocalStorageKey, this.cookieUsageAccepted = 1);
    }

  }
};